module.exports = __webpack_public_path__ + "img/Family_Packing.3b857a26.webp";